// extracted by mini-css-extract-plugin
module.exports = {"actions":"style_actions__ksEU8","stacked":"style_stacked__p8DpE","left":"style_left__QqYlV","center":"style_center__5qFor","mixed":"style_mixed__pVAK1"};